<div
  [class.tw:gap-2]="justifyPosition() === 'start' || justifyPosition() === 'end'"
  [class.tw:justify-between]="justifyPosition() === 'between'"
  [class.tw:justify-end]="justifyPosition() === 'end'"
  [class.tw:justify-start]="justifyPosition() === 'start'"
  class="tw:pb-6 tw:px-6 tw:pt-4 tw:flex tw:items-center"
>
  <prime-button
    (onClick)="noClickHandler()"
    [label]="cancelButtonLabel()"
    [text]="true"
    severity="secondary"
  ></prime-button>
  <prime-button
    (onClick)="yesClickHandler()"
    [disabled]="confirmButtonDisabled$ | async"
    [label]="confirmButtonLabel()"
  ></prime-button>
</div>
